/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import {
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { changeMainBranch } from '../../app/store/actions/app';
import { PageSettings } from '../../config/page-settings';

class SidebarProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileActive: 0,
      branchDropdownOpen: false,
      branches: [],
      changingBranch: false,
    };
    this.handleProfileExpand = this.handleProfileExpand.bind(this);
    this.toggleBranchDropdown = this.toggleBranchDropdown.bind(this);
    this.handleBranchChange = this.handleBranchChange.bind(this);
  }

  componentDidMount() {
    this.syncBranchesFromUser();
  }

  componentDidUpdate(prevProps) {
    const prevUserId = prevProps.userLogged && prevProps.userLogged.id;
    const userId = this.props.userLogged && this.props.userLogged.id;
    const prevBranches = prevProps.userLogged && prevProps.userLogged.userBranchesOptions;
    const branches = this.props.userLogged && this.props.userLogged.userBranchesOptions;

    if (prevUserId !== userId || prevBranches !== branches) {
      this.syncBranchesFromUser();
    }
  }

  handleProfileExpand(e) {
    e.preventDefault();
    this.setState((state) => ({
      profileActive: !state.profileActive,
    }));
  }

  syncBranchesFromUser = () => {
    const { userLogged } = this.props;
    const branches = (userLogged && userLogged.userBranchesOptions) || [];
    this.setState({ branches });
  };

  handleBranchChange = async (branchCode) => {
    const { userLogged, changeMainBranchAction } = this.props;

    if (
      this.state.changingBranch
      || !branchCode
      || (userLogged && userLogged.mainBranch === branchCode)
    ) {
      this.setState({ branchDropdownOpen: false });
      return;
    }

    try {
      this.setState({ changingBranch: true, branchDropdownOpen: false });
      await changeMainBranchAction(branchCode);
    } catch (error) {
      // eslint-disable-next-line
      console.log(error);
      this.setState({ changingBranch: false });
    }
  };

  toggleBranchDropdown(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState((state) => ({
      branchDropdownOpen: !state.branchDropdownOpen,
    }));
  }

  renderBranchInfo = () => {
    const { userLogged } = this.props;
    const { branches, branchDropdownOpen, changingBranch } = this.state;
    const branchLabel = (userLogged && userLogged.mainBranch && userLogged.mainBranchName)
      ? `${userLogged.mainBranch} - ${userLogged.mainBranchName}`
      : '';

    if (!branchLabel) {
      return null;
    }

    if (!branches || branches.length <= 1) {
      return <small>{branchLabel}</small>;
    }

    return (
      <small className="sidebar-branch-dropdown">
        <Dropdown
          isOpen={branchDropdownOpen}
          toggle={this.toggleBranchDropdown}
          direction="down"
        >
          <DropdownToggle
            tag="a"
            className="sidebar-branch-toggle"
            disabled={changingBranch}
          >
            <span title={branchLabel} className="sidebar-branch-label">{branchLabel}</span>
            <span className="caret" />
          </DropdownToggle>
          <DropdownMenu
            className="sidebar-branch-menu"
            container={document.body}
          >
            {branches.map((branch) => (
              <DropdownItem
                key={branch.value}
                active={userLogged && userLogged.mainBranch === branch.value}
                onClick={() => this.handleBranchChange(branch.value)}
              >
                {branch.label}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </small>
    );
  };

  render() {
    const { userLogged } = this.props;

    return (
      <PageSettings.Consumer>
        {({ pageSidebarMinify }) => (
          <ul className="nav">
            <li className="nav-profile">
              <div className="cover with-shadow" />
              <div className="image image-icon bg-black text-grey-darker">
                <i className="fa fa-user" />
              </div>
              <div className="info">
                {(userLogged && userLogged.name) || ''}
                {this.renderBranchInfo()}
                <small className="mt-1">
                  {(userLogged && userLogged.accessProfile && `${userLogged.accessProfile}`) || ''}
                </small>
              </div>
            </li>
          </ul>
        )}
      </PageSettings.Consumer>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged,
});

const mapActionsToProps = (dispatch) => ({
  changeMainBranchAction: (mainBranch) => dispatch(changeMainBranch(mainBranch)),
});

export default connect(mapStateToProps, mapActionsToProps)(SidebarProfile);
